import { ROUTES } from '@sportninja/common/constants/app'
import { invitationType } from '@sportninja/common/constants/invitationType'

const ENTITY_TYPE = {
  ORGANIZATION: 'Organization',
  TEAM: 'Team',
  COMPETITION: 'Competition',
} as const

type EntityTypeValue = (typeof ENTITY_TYPE)[keyof typeof ENTITY_TYPE]

/**
 * Returns the destination route for a given invitation type and entity id.
 * Mirrors the logic used on the InviteV2 page to avoid regressions.
 */
export const getRouteDestination = (
  invitationTypeId?: string | number | null,
  entityId?: string | number | null
): string | undefined => {
  if (!invitationTypeId || !entityId) {
    return undefined
  }

  try {
    const inviteType = invitationType.find(
      (item) => String(item.id) === String(invitationTypeId)
    )

    if (!inviteType) {
      return undefined
    }

    const id = String(entityId)
    let screen: string | undefined

    switch (inviteType.destination as EntityTypeValue) {
      case ENTITY_TYPE.ORGANIZATION:
        screen = ROUTES.ORG_PAGES.replace(/:id/, id)
        break
      case ENTITY_TYPE.TEAM:
        screen = ROUTES.TEAM_PAGES.replace(/:id/, id)
        break
      case ENTITY_TYPE.COMPETITION:
        screen = ROUTES.SCHEDULE_PAGES.replace(/:id/, id)
        break
      default:
        break
    }

    return screen
  } catch (error) {
    console.error('🚨 getRouteDestination: Failed to resolve route', error)
    return ROUTES.HOME
  }
}

export default getRouteDestination
